var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherTokensIconClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_414_1075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0344 17.1688C13.1958 16.4829 12.4036 15.835 11.8395 15.2384C11.207 14.5697 11.0742 14.1848 11.0742 13.9797C11.0742 13.7746 11.207 13.3897 11.8395 12.7209C12.4036 12.1243 13.1958 11.4764 14.0344 10.7905C16.2521 8.97678 18.7656 6.92111 18.8979 4.3639C18.9654 3.06127 18.3949 1.79046 17.2024 0.58667H3.39584C2.20208 1.79168 1.63055 3.06372 1.6971 4.36747C1.82756 6.9234 4.33261 8.97845 6.54276 10.7916C7.37839 11.4771 8.16769 12.1246 8.72974 12.7208C9.35996 13.3894 9.49226 13.7745 9.49226 13.9797C9.49226 14.1849 9.35996 14.57 8.72974 15.2385C8.16769 15.8348 7.37844 16.4823 6.54282 17.1678C4.33266 18.981 1.82756 21.036 1.69715 23.5919C1.63061 24.8957 2.20214 26.1677 3.39584 27.3726H17.2024C18.395 26.1689 18.9654 24.898 18.8979 23.5954C18.7656 21.0383 16.2521 18.9825 14.0344 17.1688Z",
    fill: "url(#paint0_linear_414_1075)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7754 26.0097H16.3036C17.0245 25.2121 17.3578 24.4471 17.3179 23.6787C17.2699 22.7468 16.6772 21.8665 16.0676 21.1658H4.51828C3.91115 21.8685 3.32516 22.7441 3.27691 23.674C3.23752 24.4444 3.57181 25.2109 4.29427 26.0097H0.791018C0.354164 26.0097 0 26.3672 0 26.8081C0 27.2491 0.354164 27.6066 0.791018 27.6066H19.7754C20.2123 27.6066 20.5664 27.2491 20.5664 26.8081C20.5664 26.3672 20.2123 26.0097 19.7754 26.0097Z",
    fill: "url(#paint1_linear_414_1075)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7754 1.94931H0.791018C0.354164 1.94931 0 1.59196 0 1.15117C0 0.710381 0.354164 0.353027 0.791018 0.353027H19.7754C20.2123 0.353027 20.5664 0.710381 20.5664 1.15117C20.5664 1.59196 20.2123 1.94931 19.7754 1.94931Z",
    fill: "url(#paint2_linear_414_1075)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_414_1075",
    x1: 10.2976,
    y1: 27.3727,
    x2: 10.2976,
    y2: 0.58667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_414_1075",
    x1: -1.79221,
    y1: 23.324,
    x2: 20.7182,
    y2: 26.5459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ADF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98A5F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_414_1075",
    x1: -1.79222,
    y1: 0.887933,
    x2: 15.4343,
    y2: 10.8361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ADF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98A5F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_414_1075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherTokensIconClock);
export default __webpack_public_path__ + "static/media/other-tokens-icon-clock.7405ba0e049f88d135b32b67f5513c01.svg";
export { ForwardRef as ReactComponent };